import Vue from 'vue'
import {_} from "vue-underscore";
import i18n from "../translation";

const state = {
    textLists: {
        textList: {},
    },
    textInstancesLists: {
        textInstances: {},
    },
    textListOptions: {},
    defaultQueryParams: {
        limit: {
            default: '50',
        },
        filter: {
            default: 'type eq text',
        },
        sort: {
            default: '-updatedAt',
        }
    },
    queryParams: {
        textList: {
            limit: {
                default: '50',
            },
            filter: {
                default: 'type eq text',
            },
            sort: {
                default: '-updatedAt',
            },
        }
    },
    combinedQueryParams: {},
    textTmp: {},
};

const getters = {
    getTexts() {
        return state.textLists.textList;
    },
    getTextsByListName: (state) => (listName) => {
        return state.textLists[listName] ? state.textLists[listName] : {};
    },
    getTextInstancesByListName: (state) => (listName) => {
        return state.textInstancesLists[listName] ? state.textInstancesLists[listName] : {};
    },
    getTextById: (state) => (id, listName = 'textList') => {
        return state.textLists[listName][id];
    },
    getTextOrganization: (state) => (id, listName = 'textList') => {
        let listContainer = 'textLists';
        return state[listContainer][listName][id] && state[listContainer][listName][id].organizationId ? state[listContainer][listName][id].organizationId : '';
    },
    getTextCreationDate: (state, rootGetters) => (id, listName = 'textList') => {
        return state.textLists[listName][id] ? rootGetters['convertDate'](state.textLists[listName][id].createdAt) : '';
    },
    getTextChangeDate: (state, rootGetters) => (id, listName = 'textList') => {
        return state.textLists[listName][id] ? rootGetters['convertDate'](state.textLists[listName][id].updatedAt) : '';
    },
    getTextPreviewUri: (state) => (id, listName = 'textList') => {
        return state.textLists[listName][id] && state.textLists[listName][id].previewUri ? state.textLists[listName][id].previewUri : '';
    },
    getTextTitle: (state) => (id, listName = 'textList') => {
        if (state.textLists[listName][id]) {
            return state.textLists[listName][id].name;
        } else {
            return '';
        }
    },
    getTextDescription: (state) => (id, listName = 'textList') => {
        if (state.textLists[listName][id]) {
            return state.textLists[listName][id].description;
        } else {
            return '';
        }
    },
    getTextContent: (state) => (id, listName = 'textList') => {
        if (state.textLists[listName][id]) {
            return state.textLists[listName][id].content;
        } else {
            return '';
        }
    },
    getTextLocale: (state) => (id, listName = 'textList') => {
        if (state.textLists[listName][id]) {
            return state.textLists[listName][id].locale;
        } else {
            return '';
        }
    },
    getTextTags: (state) => (id, listName = 'textList') => {
        return state.textLists[listName][id] && state.textLists[listName][id].tags ? state.textLists[listName][id].tags : [];
    },

    getTextMetaSets: (state) => (id, listName = 'textList') => {
        return state.textLists[listName][id] && state.textLists[listName][id].metaSets ? state.textLists[listName][id].metaSets : {};
    },
    getTextOriginalQueryParams: function() {
        return state.queryParams;
    },
    getTextQueryParams: (state) => (listName) => {
        return state.combinedQueryParams[listName];
    },
    getTextListOptions: (state) => (listName, option = '') => {
        let optionList = 'textListOptions';
        if (option === 'preview') {
            return state[optionList][listName] && state[optionList][listName].preview ? Object.keys(state[optionList][listName].preview)[0] : '';
        } else if (option === 'fbxPreview') {
            return state[optionList][listName] && state[optionList][listName].fbxPreview ? Object.keys(state[optionList][listName].fbxPreview)[0] : '';
        }
        else if(option === 'pagination_items') {
            return state[optionList][listName] && state[optionList][listName].pagination_items ? parseInt(Object.keys(state[optionList][listName].pagination_items)[0]) : 0;
        }
        return state[optionList][listName] ? state[optionList][listName] : {};
    },
};

const mutations = {
    setTextTmpMutation(state, data) {
        if (state.textTmp[data.key]) {
            Vue.delete(state.textTmp, data.key);
        }
        Vue.set(state.textTmp, data.key, data.value);
    },
    loadTextsMutation(state, data) {
        let listName = 'textList';
        if (data.listName) {
            listName = data.listName;
            delete data.listName;
        }
        Vue.set(state.textLists, listName, {});
        for (var i = 0; i < data.length; i++) {
            let project = data[i];
            Vue.set(state.textLists[listName], project.id, project);
        }
    },
    deleteTextMutation(state, data) {
        let listName = data.listName ? data.listName : 'textList';
        let id = data.id;
        if(state.textLists[listName] && state.textLists[listName][id]) {
            Vue.delete(state.textLists[listName], id);
        }
    },
    loadTextInstancesMutation (state, data) {
        let listName = 'textInstances';

        if(data.listName) {
            listName = data.listName;
            delete data.listName;
        }

        if(!state.textInstancesLists[listName]) {
            Vue.set(state.textInstancesLists, listName, {});
        }
        if(data.instanceArray) {
            let instanceArray = data.instanceArray;
            Vue.set(state.textInstancesLists, listName, {});
            for (var i = 0; i < instanceArray.length; i++) {
                let asset = instanceArray[i].asset;
                delete instanceArray[i].asset;
                let instance = instanceArray[i];
                let mixed = _.extendNonNull(asset, instance);
                Vue.set(state.textInstancesLists[listName], instance.id, mixed);
            }
        }
        else {
            let asset = data.asset;
            delete data.asset;
            let instance = data;
            data = _.extendNonNull(asset, instance);
            Vue.set(state.textInstancesLists[listName], data.id, data);
        }
    },
    deleteTextInstanceMutation (state, args) {
        if(state.textInstancesLists[args.listName][args.id]) {
            Vue.delete(state.textInstancesLists[args.listName], args.id);
        }
    },
    loadTextMutation(state, data) {
        let listName = 'textList';
        if (data.listName) {
            listName = data.listName;
            delete data.listName;
        }
        if(!state.textLists[listName]) {
            Vue.set(state.textLists, listName, {});
        }
        Vue.set(state.textLists[listName], data.id, data);
    },
    updateTextMutation(state, data) {
        for (var key in data) {
            var value = data[key];
            Vue.set(state.textLists.textList[data.id], key, value);
        }
    },
    textUpdateTagsMutation(state, data) {
        let listName = data.listName ? data.listName : 'textList';
        Vue.set(state.textLists[listName][data.id], 'tags', data.tags);
    },

    /*
    * args:
    *   assetListName (mandatory)
    *   instanceListName (mandatory)
    * */
    markTextListSelectedMutation (state, args){
        let assetLists = 'textLists';
        let instanceLists = 'textInstancesLists';
        let assetListName = args.assetListName;
        let instanceListName = args.instanceListName;

        Object.keys(state[assetLists][assetListName]).forEach(key => {
            Vue.set(state[assetLists][assetListName][key], 'selected', false);
        });

        if(state[assetLists][assetListName] && state[instanceLists][instanceListName]) {
            Object.keys(state[instanceLists][instanceListName]).forEach(key => {
                let assetId = state[instanceLists][instanceListName][key].assetId;
                if(state[assetLists][assetListName][assetId]) {
                    Vue.set(state[assetLists][assetListName][assetId], 'selected', true);
                }
            });
        }
    },
    /**
     * listName: the list to be ordered
     * order: the key to be ordered by (see switch statement)
     */
    sortTextListMutation(state, args) {
        let assetLists = 'textLists';
        let assetListName = args.listName;
        switch( args.order ){
            case 'selected':
                /*
                  Sort cafes by most liked.
                */
                // eslint-disable-next-line no-case-declarations
                let temp = state[assetLists][assetListName];
                // eslint-disable-next-line no-case-declarations
                let keys = Object.keys(state[assetLists][assetListName]).sort( function( a, b ){
                    if(temp[a].selected === temp[b].selected) {
                        return 0;
                    }
                    else if(temp[a].selected && !temp[b].selected) {
                        return -1;
                    }
                    else if(!temp[a].selected && temp[b].selected) {
                        return 1;
                    }
                });
                Vue.set(state[assetLists], assetListName, {});
                for(let i = 0; i < keys.length; i++) {
                    let key = keys[i];
                    Vue.set(state[assetLists][assetListName], key, temp[key]);
                }

            /*break;
        case 'most-liked':

            break;*/
        }
    },
    markTextSelectedMutation(state, args) {
        let listName = args.listName;
        Object.keys(args.data).forEach(key => {
            let id = args.data[key].id;
            if (state.textLists[listName] && state.textLists[listName][id]) {
                Vue.set(state.textLists[listName][id], 'selected', true);
            }
        });
    },
    setTextPropertyMutation (state, args) {
        let listName = args.listName;
        let id = args.id;
        if(state.textLists[listName][id]) {
            Vue.set(state.textLists[listName][id], args.property, args.value);
        }
    },
    setTextTopOfListMutation(state, args) {
        let listName = args.listName;
        let id = args.id;
        if(state.textLists[listName][id]) {
            let tempObj = state.textLists[listName][id];
            Vue.delete(state.textLists[listName], id);
            let newList = Object.assign(tempObj, state.textLists[listName]);
            Vue.set(state.textLists, listName, newList);
        }
    },
    updateTextListOptionMutation(state, args) {
        let optionList = 'textListOptions';
        //reset all data:
        if (!state[optionList][args.listName]) {
            Vue.set(state[optionList], args.listName, {});
        }

        if (args.override) {
            Vue.set(state[optionList][args.listName], args.optionKey, {});
        }

        //reset all other options
        if (args.optionKey === 'selected' || args.optionKey === 'preview') {
            Vue.set(state[optionList][args.listName], args.optionKey, {});
        }

        if (!state[optionList][args.listName][args.optionKey]) {
            Vue.set(state[optionList][args.listName], args.optionKey, {});
        }
        if (state[optionList][args.listName][args.optionKey][args.value]) {
            Vue.delete(state[optionList][args.listName][args.optionKey], args.value);
        } else {
            Vue.set(state[optionList][args.listName][args.optionKey], args.value, args.value2);
        }
    },
};

const actions = {
    /*
   * ------------------------ ASSETS --------------------------
   * **/
    registerTextsQueryParams: ({commit}, args) => {
        let listName = 'textList';
        if(args.listName) {
            listName = args.listName;
        }
        if(Object.keys(args).length > 0) {
            commit('queryParamsSave', {storeType: 'text', listName: listName, params: args});
        }
    },
    loadTexts: async ({commit, dispatch, getters}, args = {}) => {
        let listName = 'textList';
        if (args.listName) {
            listName = args.listName;
        }
        if (Object.keys(args).length > 0) {
            commit('queryParamsSave', {storeType: 'text', listName: listName, params: args});
        }
        commit('combineQueryParams', {storeType: 'text', listName: listName});
        dispatch('clientLoadAssets', getters.getTextQueryParams(listName)).then(data => {
            data.listName = listName;
            for (let i = 0; i < data.length; i++) {
                data[i]['editLink'] = '/library/texts/' + data[i].id + '/general';
            }
            commit('loadTextsMutation', data);

            /*added pagination part*/
            if(getters.getTextQueryParams(listName).paging === true && data.headers()) {
                let count = data.headers()['x-count'] ? parseInt(data.headers()['x-count']) : 0;
                commit('updateTextListOptionMutation', {optionKey: 'pagination_items', value: count, listName: listName, override: true});
            }
        });
    },
    loadText: async ({commit, dispatch,}, args) => {
        dispatch('clientLoadAsset', args).then(data => {
            commit('loadTextMutation', data);
            //dispatch('loadTextImagePreview', {id: args.id});
        });
    },
    textExternallyCreated: ({commit}, args) => {
        commit('setTextTmpMutation', {key: args.name, value: args.id});
    },
    createText: async ({commit, dispatch}, args) => {
        return dispatch('clientCreateAsset', args)
            .then(data => {
                commit('loadTextMutation', data);
                commit('setTextTmpMutation', {key: 'last_inserted', value: data.id});
                dispatch('createNotification', {'text': i18n.t('events.textCreated')});
                return data;
            });
    },
    updateText: async ({commit, dispatch}, args) => {
        commit('updateTextMutation', args);
        dispatch('clientSaveAsset', args).then(() => {
            dispatch('createNotification', {'text': i18n.t('events.textUpdated')});
        });
    },
    deleteText: async ({commit, dispatch}, args = {}) => {
        let listName = 'textList';
        if(args.listName) {
            listName = args.listName;
        }
        let queryArgs = args.args;
        dispatch('clientDeleteAssets', queryArgs).then(() => {
            commit('deleteTextMutation', {listName: listName, id: queryArgs});
            dispatch('createNotification', {'text': i18n.t('events.textDeleted')});
        });
    },
    addTextTag: async ({commit, dispatch}, args) => {
        dispatch('clientAddAssetTags', args).then(() => {
            dispatch('clientLoadAssetTags', args).then(data => {
                commit('textUpdateTagsMutation', {
                    id: args.id,
                    listName: args.listName ? args.listName : 'textList',
                    tags: data,
                });
            });
            dispatch('createNotification', {'text': i18n.t('events.tagsAdded')});
        });
    },
    removeTextTag:  async ({commit, dispatch}, args) => {
        dispatch('clientRemoveAssetTags', args).then(() => {
            dispatch('clientLoadAssetTags', args).then(data => {
                commit('textUpdateTagsMutation', {
                    id: args.id,
                    listName: args.listName ? args.listName : 'textList',
                    tags: data,
                });
            });
            dispatch('createNotification', {'text': i18n.t('events.tagsRemoved')});
        });
    },

    setTextListSelected: ({commit}, args) => {
        args.optionKey = 'selected';
        args.value = args.id;
        args.value2 = args.assetId;
        args.override = true;
        commit('updateTextListOptionMutation', args);

        commit('updateTextListOptionMutation', {
            id: args.id,
            listName: args.listName,
            value: args.previewUri,
            optionKey: 'preview',
        });
    },
    setTextMetaValues: async ({dispatch}, args) => {
        //commit('updateTextMutation', args);
        return dispatch('clientSaveAssetMetaSetValues', args).then(() => {
            dispatch('createNotification', {'text': i18n.t('events.textMetaValuesUpdated')});
        });
    },
    checkIfTextNameExists: async ({dispatch, getters}, args) => {
        let value = args.value;
        let orgId = args.organizationId ? args.organizationId : getters.getCurrentUserOrg;
        return dispatch('clientLoadAssets', {
            filter: ['name eq ' + value + ', organizationId eq ' + orgId /*+ ', type eq text'*/],
            fields: 'name,id',
        });
    },
    /*
    * Attention: this method is vuex-store only (no database-connection)
    * id
    * listName
    * property (string with keyname)
    * value
    * */
    setTextProperty: ({commit}, args) => {
        commit('setTextPropertyMutation', args);
    },

    /*
    * Attention: this method is vuex-store only (no database-connection)
    * id
    * listName
    * */
    setTextTopOfList: ({commit}, args) => {
        commit('setTextTopOfListMutation', args);
    },

    /*
    * Attention: this method is vuex-store only (no database-connection)
    * listName
    * order (property name)
    * */
    sortTextList: ({commit}, args) => {
        commit('sortTextListMutation', args);
    },

    /*
   * ------------------------ INSTANCES --------------------------
   * **/
    loadTextInstances: async ({commit, dispatch, getters}, args = {}) => {
        let listName = args.listName ? args.listName :'textList';

        if(Object.keys(args).length > 0) {
            commit('queryParamsSave', {storeType: 'text', listName: listName, params: args});
        }
        commit('combineQueryParams', {storeType: 'text', listName: listName});
        dispatch('clientLoadProjectInstances', getters.getTextQueryParams(listName)).then(data => {
            let args = {
                listName: listName,
                instanceArray: data,
            };
            commit('loadTextInstancesMutation', args);
        });
    },
    loadTextInstance: async ({commit, dispatch}, args = {}) => {
        let listName = args.listName ? args.listName : 'textInstanceList';

        dispatch('clientLoadProjectInstance', args).then(data => {
            //merge asset data with instance data
            /*data.listName = listName;
            let asset = data.asset;
            delete data.asset;
            let instance = data;
            data = _.extendNonNull(asset, instance);*/

            data.listName = listName;

            //todo: replace by filtering method in query (not available in api)
            if(data.asset.type === 'text') {
                commit('loadTextInstancesMutation', data);
            }

        });
    },


    /*
    * loads all connections for a spezified target/source and its projects
    * */
    loadTextConnectionsWithInstances: async ({dispatch}, args = {}) => {
        let listName = args.listName ? args.listName : 'textInstanceList';

        return dispatch('getProjectInstanceConnections', args).then(connections => {
            for (let i = 0; i < connections.length; i++) {
                let connection = connections[i];
                if(connection.targetId) {
                    let args2 = {
                        id: args.id,
                        cid: connection.targetId,
                        listName: listName,
                        include: ['asset'],
                        //filter: 'filter='+state.defaultQueryParams.filter.default,
                        //default: 'type in sensor, feed'
                    };

                    //dispatch('clientLoadProjectInstances', getters.getDatasourceQueryParams(listName)).
                    dispatch('loadTextInstance', args2);
                }
            }
        });
    },
    /*
   *   args
   *       id (required)
   *       cid (instanceId, required)
   * **/
    loadTextConnections: async ({commit, dispatch}, args = {}) => {
        let listName = args.listName ? args.listName : 'textConnections';
        args.include = 'instanceAndAsset';
        return dispatch('getProjectInstanceConnections', args).then(data => {
            let instances = [];
            for (let i = 0; i < data.length; i++) {
                if(data[i].target) {
                    let obj = data[i].target;
                    //todo: replace by filtering method in query (not available in api)

                    if(obj.asset.type === 'text') {
                        instances.push(obj);
                    }
                }
            }
            let args = {
                listName: listName,
                instanceArray: instances,
            };
            commit('loadTextInstancesMutation', args);
        });
    },
    /*
   * args
   *   id (project id)
   *   cid (source instance id)
   *
   * **/
    loadTextWithInstanceConnections: ({commit, dispatch}, args = {}) => {
        dispatch('loadTexts', args)
            .then(() => {
                args.listName = args.cid;
                args.includes = 'instanceAndAsset';
                dispatch('loadTextConnections', args)
                    .then(() => {
                        commit('markTextListSelectedMutation', {
                            assetListName: args.id,
                            instanceListName: args.cid,
                        });
                    }).then(() => {
                    commit('sortTextListMutation', {'listName': args.id, order: 'selected'});
                });
            });
    },

    /*
   * Attention: this method is vuex-store only (no database-connection)
   * id
   * listName
   * */
    removeTextInstance: ({commit}, args) => {
        commit('deleteTextInstanceMutation', args);
    },

    /*
  * ------------------------ PROJECTS --------------------------
  * **/

    loadProjectTexts: async ({commit, dispatch}, args) => {
        let listName = args.listName ? args.listName : 'textList';

        dispatch('loadTexts', args).then(() => {
            dispatch('clientLoadProjectAssets', /*getters.getTextQueryParams(listName)*/ args)
                .then(data => {
                data.listName = listName;
                data.id = args.id;
                for (let i = 0; i < data.length; i++) {
                    data[i]['editLink'] = '/library/texts/' + data[i].id + '/general';
                }
                commit('markTextSelectedMutation', {listName: listName, data: data});
            }).then(() => {
                commit('sortDatasourceListMutation', {listName: listName, order: 'selected'});
            });
        });
    },
    addProjectText: async ({dispatch}, args) => {
        dispatch('clientAddProjectAsset', args)
            .then(() => {
                dispatch('loadProjectTexts', args);
            });
    },
    removeProjectText: async ({dispatch}, args) => {
        dispatch('clientRemoveProjectAsset', args)
            .then(() => {
                dispatch('loadProjectTexts', args);
            });
    },
    loadSfxdataTexts: async ({commit, dispatch}, args) => {
        let listName = args.listName;
        //todo: this is a quickfix, send query params via save-query-params method
        args.filter = 'type eq text';
        dispatch('loadTexts', args).then(() => {
            dispatch('clientLoadProjectAssets', args).then(data => {
                commit('markTextSelectedMutation', {listName: listName, data: data});
            });
        });
    },
};
export default {
    state, getters, mutations, actions
}
